<template>
  <div class="contact-page">
  	<h1 class="title">Contact</h1>
		
		<div class="contact-page__paragraph">		
	  	<p>Tu as envie de nous envoyer un mot d'amour ou une lettre d'insultes&nbsp;? Tu as envie d'une dédicace de Boris ou d'une mèche de cheveux de Bastien (ou l'inverse)&nbsp;? Tu as envie de dire à Lucas Moulox combien tu l'aimes&nbsp;?</p>
			<p>Envoie-nous un message et promis on te répondra&nbsp;!</p>
		</div>
		
		<div class="contact-page__mail--container">
			<a href="mailto:contact@p2j.fr" class="contact-page__mail">contact@p2j.fr</a>
		</div>

    <!-- <form class="contact-page__form">
    	<div class="contact-page__input">
    		<label for="name">Prénom et nom</label>

    		<input type="text" name="name">
    	</div>

    	<div class="contact-page__input">
    		<label for="email">Votre email</label>

    		<input type="email" name="email">
    	</div>

    	<div class="contact-page__input">
    		<label for="object">Votre objet</label>

    		<input type="text" name="object">
    	</div>

    	<div class="contact-page__input">
    		<label for="content">Votre message</label>

    		<textarea name="content" resize="none"></textarea>
    	</div>

    	<input type="submit" value="Envoyer" class="btn">
    </form> -->
  </div>
</template>

<script>
	import Transition from '~mixins/Transition';
	
  export default {
    name: 'contact-page',
    mixins: [Transition],
  };
</script>


<style lang="scss">
	#app.contact {
		@include break-custom-h(620px) {		
			height: auto;
			min-height: 100%;
			padding-bottom: 20px;
		}

		@include mobile {
			min-height: 100%;

			.app-content {
				padding-top: 0;
			}
		}
	}

	.contact-page {
		padding-top: 20px;
		width: 100%;

		@include mobile {
			padding-top: 100px;
			padding-bottom: 50px;
		}
	}

	.contact-page__paragraph {
		text-align: center;
		color: $blue;
		width: 90%;
		max-width: 515px;
		margin: 0 auto 30px;
		line-height: 1.7;
		@include fontSize(17);
	}

	.contact-page__form {
		text-align: center;
		opacity: 0;
		animation: appearBottom .4s .1s ease-in-out forwards;

		input[type=submit] {
			color: $white;
	    background: $orange;
	    border-color: $orange;
	    text-align: center;
	    padding: 8px 25px;
	    margin-top: 15px;
	    cursor: pointer;
	    text-transform: uppercase;
    	@include fontSize(23);

	    &:hover {
	      background: $white;
	      color: $orange;
	    }
		}
	}

	.contact-page__input {
		display: flex;
		align-items: top;
		justify-content: center;
		text-align: left;
		margin-bottom: 10px;

		@include mobile {
			display: block;
		}

		label {
			width: 150px;
			margin-right: 35px;
			color: $blue;
			@include fontSize(18);

			@include mobile {
				display: block;
				width: 100%;
				margin-bottom: 10px;
			}
		}

		input {
			height: 40px;
			padding: 0 15px;
		}

		textarea {
			padding: 10px 15px;
			resize: none;
			min-height: 120px;
		}

		input,
		textarea {
			display: block;
			width: 100%;
			max-width: 350px;
			color: $blue;
			border: 1px solid $white;
			font-family: $main_font;
			@include fontSize(18);
		}
	}
	
	.contact-page__mail--container {
		text-align: center;
	}

	.contact-page__mail {
		color: $blue;
		@include fontSize(30);
		@include defaultTransition(.4);

		&:hover {
			color: $orange;
		}
	}
</style>



// WEBPACK FOOTER //
// Contact.vue?dda7151c